<template>
  <tr class="entry" :class="{ active: active || selected }" @click.stop="$emit('entry_click')">
    <td class="check">
      <a v-if="selected" @click.stop="$emit('selected_change', false)">
        <i class="check square outline icon blue"></i>
      </a>
      <a v-else @click.stop="$emit('selected_change', true)">
        <i class="square outline icon quickicon blue"></i>
      </a>
    </td>
    <td class="name">
      <div class="truncate">
        <span class="font-bold" :title="entry.name" v-if="entry.name">
          {{ entry.name }}
        </span>
        <span v-else>
          <i class="text-gray-600">未命名</i>
        </span>
      </div>
      <div>
        <div class="truncate" v-if="entry.url">
          <a class="text-blue-500" :href="get_url(entry)" :title="entry.url" target="_blank" @click="$event.stopPropagation()">
            {{ entry.url }}
          </a>
        </div>
      </div>
    </td>
    <td class="text-right copy hidden lg:table-cell">
      <div class="copy-username text-right">
        <a data-tooltip="复制用户名" v-if="entry.username" class="cursor-pointer quickicon"
           @click.stop="copy_to_clipboard($event, entry.username, '账号')">
          <i class="copy icon"></i>
        </a>
      </div>
      <div class="text-right">
        <a data-tooltip="复制密码" v-if="entry.password" class="cursor-pointer quickicon"
           @click.stop="copy_to_clipboard($event, entry.password, '密码')">
          <i class="copy icon"></i>
        </a>
      </div>
    </td>
    <td class="username hidden lg:table-cell">
      <div v-if="entry.username" class="truncate">
        {{ entry.username }}
      </div>
      <div v-else>
        <i class="text-gray-600">未设置账号</i>
      </div>
      <div v-if="entry.password" class="break-all">
        <span v-if="show_password">
          {{ entry.password }}
        </span>
        <span v-else>
          ••••••••••
        </span>
        <template v-if="!global_show_password">
          <a v-if="local_show_password" class="cursor-pointer ml-2"
                                        @click.stop="local_show_password=false">
            <i class="blue eye icon"></i>
          </a>
          <a v-else class="cursor-pointer quickicon ml-2"
                    @click.stop="local_show_password=true">
            <i class="eye icon"></i>
          </a>
        </template>
      </div>
    </td>
    <td class="notes hidden lg:table-cell">
      <div class="break-all notes-line notes" :title="entry_notes">
        {{ entry.notes }}
      </div>
      <div class="break-all">
        <span v-for="t in entry.tags" :key="t" class="ui mini blue tag label mr-1">
          {{ t }}
        </span>
      </div>
    </td>
    <td class="actions hidden lg:table-cell">
      <a v-if="entry.fav" data-tooltip="取消收藏"
                          @click.stop="fav_del($event, entry)">
        <i class="ui yellow text star icon"></i>
      </a>
      <a v-else data-tooltip="收藏"
                @click.stop="fav_add($event, entry)">
        <i class="ui yellow text outline star icon quickicon"></i>
      </a>
      <a class="text-dark quickicon ml-1"
         data-tooltip="创建副本"
         @click.stop="$emit('clone_entry')">
        <i class="copy icon"></i>
      </a>
      <a class="text-dark quickicon ml-1"
         data-tooltip="修改"
         @click.stop="$emit('edit')">
        <i class="edit icon"></i>
      </a>
      <a class="text-danger quickicon ml-1"
         data-tooltip="删除"
         @click.stop="delete_confirm">
        <i class="ui red text trash alternate icon"></i>
      </a>
      <Modal :id="'delete-entry-' + _uid" title="删除" @ok="$emit('delete_entry')">
        <p>确定要删除项目"{{ entry.name }}"吗？</p>
      </Modal>
    </td>
  </tr>
</template>

<script>
import Modal from './modal.vue';

export default {
  name: 'PasswordEntry',
  props: ['entry', 'active', 'selected', 'global_show_password'],
  components: {
    Modal,
  },
  data: function () {
    return {
      local_show_password: false,
    };
  },
  computed: {
    entry_notes() {
      if (!this.entry.notes) return '';
      var n = 256;
      var r = this.entry.notes.slice(0, n);
      if (this.entry.notes.length > n) {
        r += "...";
      }
      return r;
    },
    show_password() {
      return this.local_show_password || this.global_show_password;
    },
  },
  methods: {
    delete_confirm() {
      this.show_modal('delete-entry-' + this._uid);
    },
    get_url(e) {
      var u = e.url;
      if (u.startsWith("http://") || u.startsWith("https://")) {
        return u;
      }
      return "http://" + u;
    },
    copy_to_clipboard(e, text, item_name='') {
      this.$gtag.event('copy-to-clipboard', {
        event_category: 'user-action',
        event_label: 'password-manager',
      });
      var dummy = document.createElement("textarea");
      document.body.appendChild(dummy);
      dummy.value = text;
      dummy.select();
      document.execCommand("copy");
      document.body.removeChild(dummy);
      this.show_success(item_name + "已复制到剪贴板");
    },
    fav_del(e, entry) {
      this.$emit('fav_del', entry);
    },
    fav_add(e, entry) {
      this.$emit('fav_add', entry);
    }
  },
  mounted() {
  },
}
</script>

<style scoped>
.sm td.check {
  font-size: large;
}
.lg .quickicon {
  opacity: -1;
}
.lg tr:hover .quickicon {
  opacity: 1;
}
tr.active {
  background-color: #F1F4F8 !important;
}
td.actions {
  padding-left: 0 !important;
  padding-right: 0 !important;
}
.lg div.notes {
  display: block;
}
div.notes {
  display: none;
  min-height: 1.2rem;
  max-height: 3rem;
  overflow-y: auto;
}
.lg td.copy {
  width: 40px;
  max-width: 40px;
  padding-right: 0 !important;
}
.lg td.username {
  padding-left: 0 !important;
  width: 250px;
  max-width: 250px;
}
.lg td.name {
  width: 250px;
  max-width: 250px;
}
td.fav {
  width: 20px;
  max-width: 20px;
}
div.copy-username {
  min-height: 1.2rem;
}
.sm td.name {
  padding-left: 0.5rem !important;
}
</style>
